import { useEffect, useState } from 'react'
import { Image } from '@react-three/drei'

export default function AppStoreButton({ linkURL }) {
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    if (hovered) document.body.style.cursor = 'pointer'
    return () => (document.body.style.cursor = 'auto')
  }, [hovered])

  return (
    <Image
      url={'./icons/white-apple-store.png'}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
      onClick={() => window.open(linkURL, '_blank')}
      position={[0, -1.2, 0.004]}
      renderOrder={10}
      transparent
      opacity={1}
      radius={0.05}
    >
      <planeGeometry args={[1, 0.34, 20, 20]} />
    </Image>
  )
}
